module.exports = __webpack_public_path__ + "images/search_hover-a0247ae1d363d436e808c874eeeddca1.png";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images/search_hover.png
// module id = 45
// module chunks = 0